import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@material-ui/core";
import { Close } from "@mui/icons-material";

export default function DeleteDialog({
  open,
  onClose,
  onDelete,
  loading,
  name,
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h3" color="primary">
            Excluir Arquivo
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <Typography variant="caption">
          Tem certeza que deseja excluir o arquivo {name}? Esta ação não pode
          ser desfeita.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => {
            onClose();
          }}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onDelete}
          disabled={loading}
        >
          Excluir
        </Button>
      </DialogActions>
    </Dialog>
  );
}
